import { SecurityDataModel } from "Core/Components/SecurityEditor/Form/Models/SecurityDataModel";

export class UserModel {
	constructor(public Id: number, public Name: string, public UserAllowance) {

	}
}